import React from 'react'
import { FacebookShareButton, FacebookIcon, WhatsappShareButton, WhatsappIcon } from 'react-share'

const ShareButtons = (props) => {
    const URL = props?.url
  return (
    <div >
        <FacebookShareButton
        url={URL && URL}
        quote={'This is share description'}
        hastag = '#Catzapp'
        >
        <FacebookIcon size={32} round />
        </FacebookShareButton>
        <WhatsappShareButton
        url={URL && URL}
        title={'This is share description'}
         >
        <WhatsappIcon size={32} round />
         </WhatsappShareButton>
    </div>
  )
}

export default ShareButtons